<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col-12">
        <h1>Mention légales</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-4 mb-4">
        Lettre Compte Triple a pour objectif de promouvoir le Scrabble Francophone
        en proposant des solutions aux clubs de Scrabble dans l'organisation de tournois.<br />
        Lettre Compte Triple est entièrement gratuit.
      </div>
      <div class="col-12 mt-4 mb-4">
        www.lettrecomptetriple.org est édité par la société Lettre Compte Triple, SARL. <br />
        10 rue Auber<br />
        PARIS 75009<br />
        SIRET : ‎999999999<br />
      </div>
      <div class="col-12 mt-4 mb-4">
        Le site est hébergé par Amazon Web Services<br />
        Amazon Web Services, Inc.<br />
        P.O. Box 81226<br />
        Seattle, WA 98108-1226<br />
        USA<br />
        http://aws.amazon.com
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from './LoggedUser';
import BottomNav from './BottomNav';

export default {
  name: 'MentionsLegales',
  components: { LoggedUser, BottomNav },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MentionsLegales.vue